module.exports = __webpack_public_path__ + "static/media/eolica3.0e2a5483.jpeg";